import { render } from "./OfficeDesignation.vue?vue&type=template&id=7714e6d8&scoped=true"
import script from "./OfficeDesignation.vue?vue&type=script&lang=js"
export * from "./OfficeDesignation.vue?vue&type=script&lang=js"

import "./OfficeDesignation.vue?vue&type=style&index=0&id=7714e6d8&lang=scss&scoped=true"

import exportComponent from "/media/dolar/office/office_project/oneGov-admin/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7714e6d8"]])

export default __exports__